/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Controller } from "stimulus";

export default class SearchHistory extends Controller {
	declare queryValue: string;
	static values = {
		query: String,
	};

	connect() {
		const searchQueryArray = JSON.parse(
			localStorage.getItem("searchQuery") || "[]"
		) as string[];
		searchQueryArray.push(this.queryValue);
		localStorage.setItem("searchQuery", JSON.stringify(searchQueryArray));
		window.dispatchEvent(new Event("new_history_entry"));
	}
}
